import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './editor-status.reducer';

export const selectEditorStatusState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectEditorStatusState, (state: State) => state.error);

export const getLoaded = createSelector(selectEditorStatusState, (state: State) => state.loaded);

export const getAll = createSelector(selectEditorStatusState, selectAll);

export const getCount = createSelector(selectEditorStatusState, selectTotal);

export const getIds = createSelector(selectEditorStatusState, selectIds);

export const getAllEntities = createSelector(selectEditorStatusState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * editorStatus$: EditorStatusInterface[] = this.store.pipe(
    select(EditorStatusQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectEditorStatusState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * editorStatus$: EditorStatusInterface = this.store.pipe(
    select(EditorStatusQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectEditorStatusState,
  (state: State, props: { id: number }) => state.entities[props.id]
);
